<template>
  <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
       <div class="grid grid-cols-12 gap-x-4">
 <div class="col-span-full grid grid-cols-12 gap-4 card shadow-md">
                 <!-- Instructor Revenue Chart -->
             <div class="col-span-full md:col-span-6 2xl:col-span-4 p-3 dk-border-one rounded-xl h-full dk-theme-card-square shadow-md hover:shadow-lg hover:bg-gray-100 transition-all duration-300 relative">
               <h6 class="text-xs leading-none text-gray-900">Stock</h6>
               <div class="pt-3 flex gap-3.5 mt-1.5">
                   <div class="shrink-0">
                       <div class="flex items-center gap-2 mb-1.5">
                           <div class="card-title">
                               <span class="counter-value1" v-bind:data-value="(purchase) ? purchase : 0">{{ (purchase) ? formatIndianNumber(parseFloat(purchase||0)) : 0 }}</span>
                           </div>
                       </div>
                       <div class="text-xs leading-none text-gray-500 dark:text-dark-text">
                          This Year
                       </div>
                   </div>
               </div>
               <div style="border-bottom: 2px solid #3b82f6; margin-top: 0.5rem;"></div>

               <!-- Router Link without text -->
               <router-link to="/purchaselist" class="absolute inset-0"></router-link>
           </div>

           <!-- Employees Revenue Chart -->
           <div class="col-span-full md:col-span-2 2xl:col-span-3 p-3 dk-border-one rounded-xl h-full dk-theme-card-square shadow-md hover:shadow-lg hover:bg-gray-100 transition-all duration-300 relative 2xl:p-5  2xl:rounded-2xl">
               <h6 class="text-xs leading-none text-gray-900">Total Employees</h6>
               <div class="pt-3 flex gap-3.5 mt-1.5">
                   <div class="shrink-0">
                       <div class="flex items-center gap-2 mb-1.5">
                           <div class="card-title">
                               <span class="counter-value1" v-bind:data-value="(employees) ? employees : 0">{{ (employees) ? employees : 0 }}</span>
                           </div>
                       </div>
                       <div class="text-xs leading-none text-gray-500 dark:text-dark-text">
                        
                       </div>
                   </div>
               </div>
               <div style="border-bottom: 2px solid #3b82f6; margin-top: 0.5rem;"></div>

               <!-- Router Link without text -->
               <router-link to="/attendancereport" class="absolute inset-0"></router-link>
           </div>

           <!-- Consumption Chart -->
           <div class="col-span-full md:col-span-2 2xl:col-span-4 p-3 dk-border-one rounded-xl h-full dk-theme-card-square shadow-md hover:shadow-lg hover:bg-gray-100 transition-all duration-300 relative">
               <h6 class="text-xs leading-none text-gray-900">Consumption</h6>
               <div class="pt-3 flex gap-3.5 mt-1.5">
                   <div class="shrink-0">
                       <div class="flex items-center gap-2 mb-1.5">
                           <div class="card-title">
                               <span class="counter-value1" v-bind:data-value="(sale) ? sale : 0">{{ (sale) ? parseFloat(sale||0).toFixed(2) : 0 }}</span>
                           </div>
                       </div>
                       <div class="text-xs leading-none text-gray-500 dark:text-dark-text">
                           This Year
                       </div>
                   </div>
               </div>
               <div style="border-bottom: 2px solid #3b82f6; margin-top: 0.5rem;"></div>

               <!-- Router Link without text -->
               <router-link to="/salelist" class="absolute inset-0"></router-link>
           </div>

           <!-- Expenses Chart -->
           <!--<div class="col-span-full md:col-span-2 2xl:col-span-4 p-3 dk-border-one rounded-xl h-full dk-theme-card-square shadow-md hover:shadow-lg hover:bg-gray-100 transition-all duration-300 relative" v-if="userRow.role == '0'">-->
           <!--    <h6 class="text-xs leading-none text-gray-900">Expenses</h6>-->
           <!--    <div class="pt-3 flex gap-3.5 mt-1.5">-->
           <!--        <div class="shrink-0">-->
           <!--            <div class="flex items-center gap-2 mb-1.5">-->
           <!--                <div class="counter-value1 card-title" v-bind:data-value="purDue">{{ (purDue) ? purDue : 0 }}</div>-->
           <!--            </div>-->
           <!--            <div class="text-xs leading-none text-gray-500 dark:text-dark-text">-->
           <!--                 This year-->
           <!--            </div>-->
           <!--        </div>-->
           <!--        <div class="grow self-center">-->
           <!--            <div id="instructor-total-student-enroll-chart"></div>-->
           <!--        </div>-->
           <!--    </div>-->
           <!--    <div style="border-bottom: 2px solid #3b82f6; margin-top: 0.5rem;"></div>-->

               <!-- Router Link without text -->
           <!--    <router-link to="/expensesreport" class="absolute inset-0"></router-link>-->
           <!--</div>      -->
           
           
              <!-- Grapes Slaes-->
              <div class="col-span-full md:col-span-2 2xl:col-span-3 p-3 dk-border-one rounded-xl h-full dk-theme-card-square shadow-md hover:shadow-lg hover:bg-gray-100 transition-all duration-300 relative" v-if="userRow.role == '0'">
                <h6 class="text-xs leading-none text-gray-900">Grapes Sale</h6>
                <div class="pt-3 flex gap-3.5 mt-1.5">
                    <div class="shrink-0">
                        <div class="flex items-center gap-2 mb-1.5">
                            <div class="counter-value1 card-title" v-bind:data-value="grpsale">{{ (grpsale) ? parseFloat(grpsale||0).toFixed(2) : 0 }}</div>
                        </div>
                        <div class="text-xs leading-none text-gray-500 dark:text-dark-text">
                           This year
                        </div>
                    </div>
                    <div class="grow self-center">
                        <div id="instructor-total-student-enroll-chart"></div>
                    </div>
                </div>
                <div style="border-bottom: 2px solid #3b82f6; margin-top: 0.5rem;"></div>

                
                <router-link to="/saleconsumptionlist" class="absolute inset-0"></router-link>
            </div>  










</div>
            <!-- Start User By Device Section -->
            
<!-- start add table------------------------------------------------------------------------------------------------------------->
<div class="col-span-full md:col-span-full lg:col-span-full  xl:col-span-half card shadow-md">

 <div class=" ">
  <h6 class="card-title mb-1"><span v-if="userRow.role == '0'">Income/</span>Expenses</h6>
   <label for="parentId" class="block text-sm font-medium text-gray-700">Select Branch</label>
   <select v-model="selected_branch_id" class="p-2 border border-gray-300 rounded" @change="filter_plots()">
     <option value="0" >----ALL Branches---</option>
     <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>

   </select>
 
 </div>
 




<div class="grid grid-cols-12 mt-2">
 
 <!-- INITIALIZE CSS CLASS -->
  
 <!-- BASIC DATA TABLE -->
 <div class="col-span-full">
     <div class="card p-0">
         
      <div style="display: flex; flex-direction: row; gap: 16px;">
        <!-- Plot Section -->
        <div style="display: flex; align-items: center; gap: 8px;">
          <div 
            style="width: 10px; height: 10px; background-color: red; border-radius: 50%;" 
            aria-label="Red Indicator">
          </div>
          <label style="font-weight: bold;">Plot</label>
        </div>
      
        <!-- Income Section -->
        <div style="display: flex; align-items: center; gap: 8px;">
          <div 
            style="width: 10px; height: 10px; background-color: black; border-radius: 50%;" 
            aria-label="Black Indicator">
          </div>
          <label style="font-weight: bold;">Income</label>
        </div>
      </div>
      
      
     
      
      
       <div class="overflow-x-auto" >
       <table id="languageTable" table class="min-w-full divide-y divide-gray-200">
   <thead class="bg-gray-50" > 
                     <tr>
                      <th  scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Branch</th>
                         <th  scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" >Plot</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Jan</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Feb</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Mar</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Apr</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >May</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Jun</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >July</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Aug</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Sept</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Oct</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Nov</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Dec</th>
                         <th  scope="col"           class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"         >Total</th>
                     </tr>
                 </thead>
                 <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                     <tr v-for="(item, index) in filtered_branchLists" :key="item.id">
                      <td class="px-6 py-4 whitespace-nowrap">{{ item.branchname }}</td>
                      <td class="px-6 py-4 whitespace-nowrap">{{ item.plotname }}</td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.jan !== 0 ? item.jan : ''  }}</span> <span class="text-succes"> {{item.jangrapes_sales !== 0 ? '/'+item.jangrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.feb !== 0 ? item.feb : '' }}</span> <span class="text-succes"> {{item.febgrapes_sales !== 0 ? '/'+item.febgrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.mar !== 0 ? item.mar : '' }}</span> <span class="text-succes"> {{item.margrapes_sales !== 0 ? '/'+item.margrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.apr !== 0 ? item.apr : '' }}</span> <span class="text-succes"> {{item.aprgrapes_sales !== 0 ? '/'+item.aprgrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.may !== 0 ? item.may : '' }}</span> <span class="text-succes"> {{item.maygrapes_sales !== 0 ? '/'+item.maygrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.jun !== 0 ? item.jun : '' }}</span> <span class="text-succes"> {{item.jungrapes_sales !== 0 ? '/'+item.jungrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.jul !== 0 ? item.jul : '' }}</span> <span class="text-succes"> {{item.julgrapes_sales !== 0 ? '/'+item.julgrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.aug !== 0 ? item.aug : '' }}</span> <span class="text-succes"> {{item.auggrapes_sales !== 0 ? '/'+item.auggrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.sep !== 0 ? item.sep : '' }}</span> <span class="text-succes"> {{item.sepgrapes_sales !== 0 ? '/'+item.sepgrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.oct !== 0 ? item.oct : '' }}</span> <span class="text-succes"> {{item.octgrapes_sales !== 0 ? '/'+item.octgrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.nov !== 0 ? item.nov : '' }}</span> <span class="text-succes"> {{item.novgrapes_sales !== 0 ? '/'+item.novgrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.dec !== 0 ? item.dec : '' }}</span> <span class="text-succes"> {{item.decgrapes_sales !== 0 ? '/'+item.decgrapes_sales : ''}}</span></td>
                      <td class="px-6 py-4 whitespace-nowrap"><span class="text-danger">{{ item.total_row_exp !== 0 ? item.total_row_exp : '' }}</span> <span class="text-succes"> {{item.total_row_grapes_sales !== 0 ? '/'+item.total_row_grapes_sales : ''}}</span></td>
                      
                        
                       
                         
                     </tr>
                 </tbody>
             </table>
         </div>
     </div>
 </div>
</div>


</div>




<!-- end add table--------------------------------------------------------------------------------------------------------------->


<!-- start net profit --------------------------------------------------------------------------------------------------------------->

<div class="col-span-full md:col-span-full lg:col-span-full  xl:col-span-6 card shadow-md" v-if="userRow.role == '0'">
  <h6 class="card-title">Net Profit</h6>
  <div class="overflow-x-auto">
    <table id=" " class="datatable mt-3 w-full text-sm text-left text-gray-500 netProfitTable">
      <thead class="text-xs text-gray-700 uppercase bg-[#B2E8D9]">
        <tr>
          <th scope="col" class="px-4 py-2">SR No</th>
          <th scope="col" class="px-4 py-2">Ledger Name</th>
          <th scope="col" class="px-4 py-2">Income</th>
          <th scope="col" class="px-4 py-2">Expenses</th>         
          <th scope="col" class="px-4 py-2">Asset(Exps)</th>
          <th scope="col" class="px-4 py-2">Net Profit</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
        <tr v-for="(item, index) in profitList" :key="item.id" class="bg-white hover:bg-gray-50">
          <td class="px-4 py-2">{{ index + 1 }}</td>
          <td class="px-4 py-2">{{ item.name }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(item.totalincome) }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(item.totalexpenses) }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(item.total_asset) }}</td>
          <td class="px-4 py-2">
            {{ (parseInt(item.totalincome || 0)) - parseInt(item.totalexpenses || 0) }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="font-bold text-right">Total:</td>
          <td class="font-bold">{{ formatIndianNumber(income) }}</td>
          <td class="font-bold">{{ formatIndianNumber(expenses) }}</td>
          <td class="font-bold">{{ formatIndianNumber(Asset) }}</td>
          <td class="font-bold">{{ formatIndianNumber(netprofit) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<!------------------------------------------------------start Manpower table------------------------------------ -->

<div class="col-span-full 3xl:col-span-8 card shadow-md" >
  <h6 class="card-title text-lg leading-none">Total Labour Count</h6>
  <div class="grid grid-cols-12 mt-2">
    <!-- BASIC DATA TABLE -->

    <div class="col-span-full">
      <div class="card p-0">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <select class="form-input form-select" v-model="data_month">
                <option value="P">Previous Month</option>
                <option value="C">This Month</option>
            </select>
              <tr >
                  <th  class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">DAYS </th>
                <th v-for="(item, index) in manpower" :key="index"  class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"  @click="handleClick(item)"><b>{{ item.x }}</b></th> 
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
              
              <tr>
                  <th  class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">MANPOWER </th>
                <td  v-for="(item, index) in manpower" :key="index" class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" @click="handleClick(item)">{{ item.y }}</td> 
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


<!------------------------------------------------------end Manpower table------------------------------------ -->

<!-- start Due amount --------------------------------------------------------------------------------------------------------------->

<div class="col-span-full md:col-span-7 lg:col-span-7 card shadow-md" v-if="userRow.role == '0'">
  <h6 class="card-title">Grapes Sale Due Amount</h6>
  <div class="overflow-x-auto">
    <table id=" " class="datatable mt-3 w-full text-sm text-left text-gray-500 netProfitTable">
      <thead class="text-xs text-gray-700 uppercase bg-[#B2E8D9]">
        <tr>
          <th scope="col" class="px-4 py-2">SR No</th>
          <th scope="col" class="px-4 py-2">Party Name</th>
          <th scope="col" class="px-4 py-2">Party Contact</th>
          <th scope="col" class="px-4 py-2">Total Amount</th>
          <th scope="col" class="px-4 py-2">Paid Amount</th>
          <th scope="col" class="px-4 py-2">Due Amount</th>         
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
        <tr v-for="(item, index) in partydueList" :key="item.id" class="bg-white hover:bg-gray-50">
          <td class="px-4 py-2">{{ index + 1 }}</td>
          <td class="px-4 py-2">{{ item.name }}</td>
          <td class="px-4 py-2">{{ item.contact }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(item.amount) }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(item.paid) }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(item.dueamt) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3" class="font-bold text-right">Total:</td>
          <td class="font-bold">{{ formatIndianNumber(grapes_sale_amt) }}</td>
          <td class="font-bold">{{ formatIndianNumber(grapes_sale_paid) }}</td>
          <td class="font-bold">{{ formatIndianNumber(grapes_sale_due) }}</td>
          
          
        </tr>
      </tfoot>
    </table>
  </div>
</div>




 <!-- end Due amount----------------------------------------------------------------------------------------------------------------->



<!-- start Due amount --------------------------------------------------------------------------------------------------------------->

<div class="col-span-full md:col-span-7 lg:col-span-7 card shadow-md" >
  <h6 class="card-title">Fuel Stock</h6>
  <div class="overflow-x-auto">
    <table id="basicDataTable" class="datatable mt-3 w-full text-sm text-left text-gray-500">
      <thead class="text-xs text-gray-700 uppercase bg-[#B2E8D9]">
        <tr>
          <th scope="col" class="px-4 py-2">SR No</th>
          <th scope="col" class="px-4 py-2">Branch Name</th>
          <th scope="col" class="px-4 py-2">Fuel Name</th>
          <th scope="col" class="px-4 py-2">Available<br>Fuel Stock</th>
          
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
        <tr v-for="(item, index) in dashboardfuelstock" :key="item.id" class="bg-white hover:bg-gray-50">
          <td class="px-4 py-2">{{ index + 1 }}</td>
          <td class="px-4 py-2">{{ item.branch_name }}</td>
          <td class="px-4 py-2">{{ item.fuel_name }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(item.totalfuelstock)}}</td>
         

  
        </tr>
      </tbody>
       <tfoot>
        <tr>
          <td colspan="3" class="font-bold text-right">Total:</td>
          <td class="font-bold">{{ formatIndianNumber(fule_stock_value) }}</td> 
        </tr>
      </tfoot>
    </table>
  </div>
</div>




 <!-- end Due amount----------------------------------------------------------------------------------------------------------------->





<!-- start Due amount --------------------------------------------------------------------------------------------------------------->

<div class="col-span-full md:col-span-7 lg:col-span-7 card shadow-md ml-3" v-if="userRow.role == '0'">
  <h6 class="card-title">Available Stock</h6>
  <div class="overflow-x-auto">
    <table id="basicDataTable" class="datatable mt-3 w-full text-sm text-left text-gray-500">
      <thead class="text-xs text-gray-700 uppercase bg-[#B2E8D9]">
        <tr>
          <th scope="col" class="px-4 py-2">SR No</th>
          <th scope="col" class="px-4 py-2">Branch Name</th>
          <th scope="col" class="px-4 py-2">Available Stock Amount</th>  
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
        <tr v-for="(item, index) in branchWiseStock " :key="item.id" class="bg-white hover:bg-gray-50">
          <td class="px-4 py-2">{{ index + 1 }}</td>
          <td class="px-4 py-2">{{ item.branch_name }}</td>
          <td class="px-4 py-2">{{ formatIndianNumber(parseFloat(item.total)) }}</td>

  
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="font-bold text-right">Total:</td>
          <td class="font-bold">{{ formatIndianNumber(availablestock) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>




 <!-- end Due amount----------------------------------------------------------------------------------------------------------------->





<!-- start Due amount --------------------------------------------------------------------------------------------------------------->

<div class="col-span-full md:col-span-7 lg:col-span-7 card shadow-md ml-3" v-if="userRow.role == '0'">
  <h6 class="card-title">Consumption Stock</h6>
  <div class="overflow-x-auto">
    <table id="basicDataTable" class="datatable mt-3 w-full text-sm text-left text-gray-500">
      <thead class="text-xs text-gray-700 uppercase bg-[#B2E8D9]">
        <tr>
          <th scope="col" class="px-4 py-2">SR No</th>
          <th scope="col" class="px-4 py-2">Branch Name</th>
          <th scope="col" class="px-4 py-2">Total Amount</th> 
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
        <tr v-for="(item, index) in filteredConsumptionList " :key="item.id" class="bg-white hover:bg-gray-50">
          <td class="px-4 py-2">{{ index + 1 }}</td>
          <td class="px-4 py-2">{{ item.branch_name }}</td>
          <td class="px-4 py-2">{{ parseFloat(item.consumptiontotal).toFixed(2) }}</td>

  
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="font-bold text-right">Total:</td>
          <td class="font-bold">{{ formatIndianNumber(consumptionstock) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>




 <!-- end Due amount----------------------------------------------------------------------------------------------------------------->







<!-- start Due amount --------------------------------------------------------------------------------------------------------------->

<div class="col-span-full md:col-span-7 lg:col-span-7 card shadow-md ml-3" v-if="userRow.role == '0'">
  <h6 class="card-title">Grapes Sale</h6>
  <div class="overflow-x-auto">
    <table id="basicDataTable" class="datatable mt-3 w-full text-sm text-left text-gray-500">
      <thead class="text-xs text-gray-700 uppercase bg-[#B2E8D9]">
        <tr>
          <th scope="col" class="px-4 py-2">SR No</th>
          <th scope="col" class="px-4 py-2">Branch Name</th>
          <th scope="col" class="px-4 py-2">Total Amount</th> 
          <th scope="col" class="px-4 py-2">Paid Amount</th> 
          <th scope="col" class="px-4 py-2">Due Amount</th> 
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
        <tr v-for="(item, index) in saleconsumptionList " :key="item.id" class="bg-white hover:bg-gray-50">
          <td class="px-4 py-2">{{ index + 1 }}</td>
          <td class="px-4 py-2">{{ item.branch_name }}</td>
          <td>{{ formatIndianNumber(item.total_amount) }}</td>
          <td>{{ formatIndianNumber(item.paid_amount) }}</td>
          <td>{{ formatIndianNumber(parseInt(item.total_amount||0)-parseInt(item.paid_amount||0)) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="font-bold text-right">Total:</td>
          <td class="font-bold">{{ formatIndianNumber(totalamount) }}</td>
          <td class="font-bold">{{ formatIndianNumber(paidamount) }}</td>
          <td class="font-bold">{{ formatIndianNumber(dueamount) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>




 <!-- end Due amount----------------------------------------------------------------------------------------------------------------->








 <!-- end net profit----------------------------------------------------------------------------------------------------------------->

           <!-- End User By Device Section -->
<div class="col-span-full 3xl:col-span-8 card shadow-md">
               <div class="flex-center-between">
                   <h6 class="card-title">Plot Expenses</h6>
                   <!--<select class="form-input form-select">-->
                   <!--    <option value="this-month">This Year</option>-->
                   <!--    <option value="last-month">This Month</option>-->
                   <!--</select>-->
               </div>
               <div id="admin-average-registration-chart"></div>              
           </div>
                     <div class="col-span-full md:col-span-7 lg:col-span-7 card shadow-md">
            <div class="flex-center-between">
                <h6 class="card-title text-lg leading-none">Category Consumption</h6>
                <!--<div class="leading-none shrink-0 text-xs text-gray-500 dark:text-dark-text dk-border-one rounded-full px-2 py-1 dk-theme-card-square">07 Days</div>-->
            </div>
            <div class="session-browser-chart flex-center h-full">
                <div id="browser-session-chart"></div>
            </div>
        </div>
           <!-- End Session By Browser Chart -->
         <!-- Start Instructor Earning Section -->
           <div class="col-span-full card px-5 py-4 md:col-span-6 lg:col-span-8 shadow-md">
               <div class="dk-border-one px-5 py-3">
                   <div class="flex-center-between">
                       <h6 class="card-title">Manpower</h6>
                       <select class="form-input form-select">
                           <option value="this-month">This Month</option>
                           <option value="this-year">This Year</option>
                       </select>
                   </div>
                   <div id="instructor-monthly-earning-chart"></div>              
               </div>
           </div>








  <!-- Start Session By Browser Chart -->

<!-- End Instructor Earning Section -->









           <!-- End Session By Browser Chart -->
 
           <!-- End Chat Inbox -->
       </div>
   </div>
</template>
<style>
  .grid-cols-12 {
  grid-template-columns: repeat(15, minmax(0, 1fr));
}
  </style>
<script>
// @ is an alias to /src 
import axios from 'axios';

export default {
 name: 'HomeView', 
mounted(){
this.getBasics();
}, 
data() {
return {
       sale:'',
       purchase:'',
       saleDue:150,
       purDue:'',
       grpsale:'',
       stock:0, 
       delivList:[],
       piechart:[],
       branchList:[],
       branchLists:[],
       filtered_branchLists:[],
       saleconsumptionList:[],
       filteredConsumptionList:[],
       exp_graph_data:[],
       dashboardfuelstock:[],
       branchWiseStock :[],
       employees:'',
       manpower:[],
       profitList:[],
       partydueList:[],
       selected_branch_id:0,
       userRow:{role:'0'},
       branch:{

       },
       manpower_xvalues:[],
       data_month:'C',

       pie_series:[],
       pie_colors: ["#5F71FA", "#FF5733", "#34A853", "#FFD700", "#6A5ACD", "#FF69B4","#f4978e"],
       pie_labels:[]

}
}, 


computed: {
  income() {
        return this.profitList.reduce(
            (total, item) => total + (parseFloat(item.totalincome) || 0), 0
        ).toFixed(2);
    },
    expenses() {
        return this.profitList.reduce(
            (total, item) => total + (parseFloat(item.totalexpenses) || 0), 0
        ).toFixed(2); // Fixed to 2 decimal places for currency consistency
    },


    Asset() {
        return this.profitList.reduce(
            (total, item) => total + (parseFloat(item.total_asset) || 0), 0
        ).toFixed(2); // Fixed to 2 decimal places for currency consistency
    },

    netprofit() {
      return (this.profitList || []).reduce(
                    (total, item) => total + parseFloat(item.totalincome || 0) - parseFloat(item.totalexpenses || 0),
                    0
                ).toFixed(2);
},

availablestock() {
        return this.branchWiseStock.reduce(
            (total, item) => total + (parseFloat(item.total) || 0), 0
        ).toFixed(2);
    },

    consumptionstock() {
        return this.filteredConsumptionList.reduce(
            (total, item) => total + (parseFloat(item.consumptiontotal) || 0), 0
        ).toFixed(2);
    },



    totalamount() {
        return this.saleconsumptionList.reduce(
            (total, item) => total + (parseFloat(item.total_amount) || 0), 0
        );
    },

    paidamount() {
        return this.saleconsumptionList.reduce(
            (total, item) => total + (parseFloat(item.paid_amount) || 0), 0
        );
    },


    dueamount() {
      return (this.saleconsumptionList || []).reduce(
                    (total, item) => total + (item.total_amount || 0) - (item.paid_amount || 0),
                    0
                );
},



//01.02.2025
 grapes_sale_amt() {
        return this.partydueList.reduce(
            (total, item) => total + (parseFloat(item.amount) || 0), 0
        );
    },
     grapes_sale_paid() {
        return this.partydueList.reduce(
            (total, item) => total + (parseFloat(item.paid) || 0), 0
        );
    }, grapes_sale_due() {
        return this.partydueList.reduce(
            (total, item) => total + (parseFloat(item.dueamt) || 0), 0
        );
    },


fule_stock_value() {
        return this.dashboardfuelstock.reduce(
            (total, item) => total + (parseFloat(item.totalfuelstock) || 0), 0
        );
    },






},



 methods:{
formatIndianNumber(value) {
      return new Intl.NumberFormat('en-IN').format(value);
    },
   filter_plots(){
       
         if ($.fn.dataTable.isDataTable('#languageTable')) {
                        $('#languageTable').DataTable().destroy();
                    }  
       if(this.selected_branch_id>0)
           this.filtered_branchLists= this.branchLists.filter(branch => branch.branchid === this.selected_branch_id);
        else
           this.filtered_branchLists=this.branchLists;
            this.$nextTick(() => {
                 $('#languageTable').DataTable();
             });
   },
   handleClick(item) {
   // alert(`Selected date: ${date}`);
    //alert("hello")
  
    this.$router.push({ name: 'filterattendancereport',query:{filterdate: item.x,month:this.data_month} });
   
    
  },
       refreshDatatble() {
              $('.netProfitTable').DataTable( {
                dom: 'Bfrtip',
                "bPaginate": false,
                buttons: [
                    'print',
                    'excelHtml5',
                    'csvHtml5',
                    'pdfHtml5'
                ]
            } );
         },
async getBasics() {
      var self=this;
        axios.post('getDashboard').then(function (response) {
              if(!response.data){
                location.replace('http://157.173.221.162:8082/');

              }else{
                 self.purchase=response.data.purchase[0].total;
                 self.employees=response.data.employees[0].total1;
                 self.sale=response.data.sale;
                 self.purDue=response.data.purDue[0].total3;
                 self.grpsale=response.data.grpsale[0].total5;
                self.manpower_xvalues=response.data.manpower;
               //  self.saleDue=response.data.saleDue;
                
               //  self.stock=response.data.stock;
                self.userRow=response.data.userRow;
                self.delivList=response.data.delivList;
                self.branchList=response.data.branch;
                self.branchLists=response.data.retn_array;
                self.filtered_branchLists=self.branchLists;
                self.manpower=self.manpower_xvalues;
                self.piechart=response.data.piechart;
                self.profitList=response.data.profitlist;
                self.partydueList=response.data.partyduelist;
                self.dashboardfuelstock=response.data.Dashboardfuelstock;
                self.branchWiseStock = response.data.branchwise_stock;
                self.filteredConsumptionList = response.data.consumption_list;
                self.saleconsumptionList = response.data.saleconsumptionlists;

// start----------------------------------------------------------------------------------------------------------------------
                for (let index = 0; index < self.piechart.length; index++) {
                  const element = self.piechart[index];
                  try {
                    self.pie_series.push(parseInt(element.qty));
                    self.pie_labels.push(""+element.cat_name); 
                    
                  } catch (error) {
                    
                  }
                }
                
              }
               }).then(()=>{ 
               // console.log("pie");
             // console.log(self.pie_series);
                                        // Browser Session Chart

        $('#languageTable').DataTable();
        self.refreshDatatble();

              const browserSessionOptions = {
              series: self.pie_series,
              chart: {
                height: 320,
                type: "pie",
                events: {
                  mounted: (chart) => {
                    chart.windowResizeHandler();
                  },
                },
              },
              labels: self.pie_labels,
              colors: self.pie_colors,
              legend: {
                position: "bottom",
                offsetY: 0,
                markers: {
                  width: 7,
                  height: 7,
                  radius: 99,
                  offsetX: -3,
                  offsetY: -1,
                },
                itemMargin: {
                  horizontal: 10,
                },
              },
              theme: {
                monochrome: {
                  enabled: false,
                },
              },
              plotOptions: {
                pie: {
                  expandOnClick: false,
                  dataLabels: {
                    offset: -10,
                    minAngleToShowLabel: 10,
                  },
                },
              },
              stroke: {
                show: false,
              },
              };

              const browserSessionChart = new ApexCharts(
              document.querySelector("#browser-session-chart"),
              browserSessionOptions
              );
              browserSessionChart.render();


// end-------------------------------------------------------------------------------------------

                   self.exp_graph_data.splice(0);
                   for(var i=0;i<self.branchLists.length;i++){
                       
                       self.exp_graph_data.push({name:self.branchLists[i].plotname,data:[
parseInt(self.branchLists[i].jan),parseInt(self.branchLists[i].feb),parseInt(self.branchLists[i].mar),parseInt(self.branchLists[i].apr),
parseInt(self.branchLists[i].may),parseInt(self.branchLists[i].jun),parseInt(self.branchLists[i].jul),parseInt(self.branchLists[i].aug),
parseInt(self.branchLists[i].sep),parseInt(self.branchLists[i].oct),parseInt(self.branchLists[i].nov),parseInt(self.branchLists[i].dec) ] });


// add sales data
self.exp_graph_data.push({name:self.branchLists[i].plotname+" Grapes Sales",data:[
parseInt(self.branchLists[i].jangrapes_sales),parseInt(self.branchLists[i].febgrapes_sales),parseInt(self.branchLists[i].margrapes_sales),parseInt(self.branchLists[i].aprgrapes_sales),
parseInt(self.branchLists[i].maygrapes_sales),parseInt(self.branchLists[i].jungrapes_sales),parseInt(self.branchLists[i].julgrapes_sales),parseInt(self.branchLists[i].auggrapes_sales),
parseInt(self.branchLists[i].sepgrapes_sales),parseInt(self.branchLists[i].octgrapes_sales),parseInt(self.branchLists[i].novgrapes_sales),parseInt(self.branchLists[i].decgrapes_sales) ] });


                   }
                   
                   console.log(self.exp_graph_data);
                    
// Average Registration Rate Chart
const averageRegistrationOptions = {
 chart: {
   type: "line",
   height: 320,
   width: "100%",
   offsetX: -5,
   offsetY: 15,
   toolbar: {
     show: true,
   },
 stroke: {
   show: true,
   width:50,
 },
   events: {
     mounted: (chart) => {
       chart.windowResizeHandler();
     },
   },
 },
 xaxis: {
   categories: [
     "Jan",
     "Feb",
     "Mar",
     "Apr",
     "May",
     "Jun",
     "Jul",
     "Aug",
     "Sep",
     "Oct",
     "Nov",
     "Dec",
   ],
 },
 yaxis: {
   tickAmount: 5,
   // labels: {
   //   formatter: (val) => val + "k",
   // },
 },
  series: self.exp_graph_data,
//     [{
//       name: "Plot 1",
//       data: [73, 49, 29, 56, 99, 50, 80, 40, 90, 45, 58, 88],
//     },
//     {
//       name: "Plot 2",
//       data: [22, 39, 49, 73, 29, 60, 40, 55, 20, 63, 55, 65],
//     },
//     {
//       name: "Plot 3",
//       data: [12, 89, 29, 43, 69, 20, 70, 75, 35, 23, 50, 15],
//     },
//   ],
 plotOptions: {
   bar: {
     horizontal: false,
     columnWidth: "18%",
     endingShape: "rounded",
   },
 },
 grid: {
   borderColor: "#EEE",
 },
 dataLabels: {
   enabled: false,
 },
 stroke: {
   curve: "smooth",
   colors: ["#5F71FA", "#000000", "#b30073"],
   width: 1,
 }, 
 legend: {
   position: "top",
   horizontalAlign: "left",
   offsetX: -30,
   offsetY: 0,
   markers: {
     width: 7,
     height: 7,
     radius: 99,
     fillColors: ["#5F71FA", "#76D466"],
     offsetX: -3,
     offsetY: -1,
   },
   itemMargin: {
     horizontal: 20,
   },
 },
 tooltip: {
   y: {
     formatter: (val) => {
       return val + "k";
     },
   },
 },
};

const averageRegistration = new ApexCharts(
 document.querySelector("#admin-average-registration-chart"),
 averageRegistrationOptions
);
averageRegistration.render();


// revenur

// Insturctor Earning Chart
const instructorEarningOptions = {
 chart: {
   type: "area",
   height: 250,
   toolbar: {
     show: false,
   },
   zoom: {
     autoScaleYaxis: true,
   },
   events: {
     mounted: (chart) => {
       chart.windowResizeHandler();
     },
   },
 },
 series: [
   {
     name: "Manpower Expenses",
     data: self.manpower_xvalues,
   },
 ],
 yaxis: { 
   tickAmount: 5,
   decimalsInFloat: false,
   labels: {
     formatter: (val) => val + "",
   },
 },
 grid: {
   borderColor: "#EEE",
 },
 dataLabels: {
   enabled: false,
 },
 stroke: {
   show: true,
   colors: ["#5F71FA"],
   width: 1,
 },
 fill: {
   type: "gradient",
   gradient: {
     opacityFrom: 0.5,
     opacityTo: 0.2,
     stops: [0, 60],
   },
 },
 tooltip: {
   y: {
     formatter: (val) => {
       return val + "";
     },
   },
 },
};

const instructorEaringChart = new ApexCharts(
 document.querySelector("#instructor-monthly-earning-chart"),
 instructorEarningOptions
);
instructorEaringChart.render();


                   });;;
 }, 
 
 
 }
}
</script>
//original home view